import { Link } from 'react-router-dom';
import './FooterStyle.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="Footer bg-dark-custom text-white">
      <div className="Footer__inner container-fluid container-lg px-3 px-md-4">
        <div className="row py-4 py-md-5 g-4">
          {/* About Section */}
          <div className="col-12 col-md-6 col-lg-4 mb-3 mb-lg-0 text-center text-lg-start">
            <h5 className="Footer__heading d-inline-block">
              <i className="bi bi-moon-stars-fill me-2"></i>
              About ICCVT
            </h5>
            <p className="Footer__text mx-auto mx-lg-0">
              The Islamic Community Center of Vermont® serves the Muslim community with education, guidance, and support. We are dedicated to fostering faith, building community, and nurturing the next generation.
            </p>
          </div>

          {/* Quick Links */}
          <div className="col-12 col-md-6 col-lg-4 mb-3 mb-lg-0 text-center text-lg-start">
            <h5 className="Footer__heading d-block">Quick Links</h5>
            <ul className="list-unstyled Footer__navList d-inline-block d-lg-block text-start">
              <li className="w-100">
                <Link to="/" className="Footer__navLink">
                  <i className="bi bi-chevron-right me-2"></i>
                  Home
                </Link>
              </li>
              <li className="w-100">
                <Link to="/about/mission" className="Footer__navLink">
                  <i className="bi bi-chevron-right me-2"></i>
                  Our Mission
                </Link>
              </li>
              <li className="w-100">
                <Link to="/services/madarasa" className="Footer__navLink">
                  <i className="bi bi-chevron-right me-2"></i>
                  Madarasa
                </Link>
              </li>
              <li className="w-100">
                <Link to="/contact" className="Footer__navLink">
                  <i className="bi bi-chevron-right me-2"></i>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-12 col-lg-4 text-center text-lg-start">
            <h5 className="Footer__heading d-inline-block">Contact Us</h5>
            <ul className="list-unstyled Footer__contactList">
              <li className="mb-2 justify-content-center justify-content-lg-start text-start">
                <i className="bi bi-geo-alt-fill me-2"></i>
                <span className="Footer__contactContent">
                  88 Malletts Bay Ave, Suite 1,<br />
                  Winooski, VT 05404
                </span>
              </li>
              <li className="mb-2 justify-content-center justify-content-lg-start text-start">
                <i className="bi bi-telephone-fill me-2"></i>
                <a href="tel:802-430-9252" className="Footer__navLink Footer__contactLink">802-430-9252</a>
              </li>
              <li className="mb-2 justify-content-center justify-content-lg-start text-start">
                <i className="bi bi-envelope-fill me-2"></i>
                <a href="mailto:weliabdullahi@gmail.com" className="Footer__navLink Footer__contactLink">
                  Submit an inquiry
                </a>
              </li>
            </ul>

            <div className="d-flex flex-wrap gap-3 mt-3 justify-content-center justify-content-lg-start">
              <a href="https://facebook.com" className="Footer__socialLink" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://twitter.com" className="Footer__socialLink" aria-label="Twitter">
                <i className="bi bi-twitter"></i>
              </a>
              <a href="https://instagram.com" className="Footer__socialLink" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="https://youtube.com" className="Footer__socialLink" aria-label="YouTube">
                <i className="bi bi-youtube"></i>
              </a>
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="Footer__bottom py-3 py-md-4">
          <div className="row align-items-center g-2 g-md-3">
            <div className="col-12 col-md-6 text-center text-md-start mb-2 mb-md-0">
              <p className="mb-0 small">
                &copy; {currentYear} Islamic Community Center of Vermont. All rights reserved.
              </p>
            </div>
            <div className="col-12 col-md-6 text-center text-md-end">
              <p className="mb-0 small">
                Crafted by {' '}
                <a href="https://cititekpro.com/" target="_blank" rel="noopener noreferrer" className="Footer__navLink">
                  CitiTekPro
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
